import { primitiveTokens, semanticThemeTokens } from "@appretio/ui-kit";
import { style } from "@vanilla-extract/css";

export const body = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["3x"]
});

export const summaryList = style({
  margin: 0,
  paddingLeft: primitiveTokens.sizing["5x"],
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["1x"]
});

export const summaryItem = style({
  fontSize: semanticThemeTokens.dialog.description.fontSize
});

export const footer = style({
  display: "flex",
  justifyContent: "flex-end",
  gap: primitiveTokens.sizing["2x"],
  marginTop: primitiveTokens.sizing["2x"]
});
